require('./bootstrap');

import Alpine from 'alpinejs';
import Focus from '@alpinejs/focus'

import Tooltip from "@ryangjchandler/alpine-tooltip";

Alpine.plugin(Focus);
Alpine.plugin(Tooltip);

window.Alpine = Alpine;

Alpine.start();
